export enum ColumnWidths {
  name = 7,
  state = 2,
  status = 2,
  expiration = 1,
}
